export default __webpack_public_path__ + "static/Gotham-Book-408b2fd394dd270065c17bfe02c5e18c.woff";